import { ClipCostSummary } from '../../api/clip';
import { usdToCredits } from '../../api/structs/model';
import { ClipPrompt } from '../../api/structs/clip';

const toCaptionString = (value: unknown): string => {
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return '';
};

export const extractCaption = (clip: Pick<ClipPrompt, 'metadata'>): string => {
  const metadata = clip.metadata || {};
  const caption = metadata.caption
    ?? metadata.post_caption
    ?? metadata.postCaption
    ?? metadata.social_caption
    ?? metadata.socialCaption;
  return toCaptionString(caption);
};

/** The clip's cost in credits: the ledger's charged amount when the backend
 *  has it, else the telemetry USD priced with the markup (older clips). */
export const clipCostCredits = (summary: ClipCostSummary): number =>
  summary.total_credits && summary.total_credits > 0
    ? summary.total_credits
    : usdToCredits(summary.total_usd ?? 0);

const formatUsd = (usd: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(usd);

/** The shared run spend, labelled as such, or '' when there is none. */
export const formatSharedRunCost = (summary: ClipCostSummary, display: 'credits' | 'usd'): string => {
  const credits = summary.run_credits ?? 0;
  if (credits <= 0) return '';
  return display === 'credits'
    ? `run ⚡ ${credits.toLocaleString()}`
    : `run ${formatUsd(summary.run_usd ?? 0)}`;
};

export const formatClipCost = (summary: ClipCostSummary): string => formatUsd(summary.total_usd ?? 0);
